import React, { useState, useEffect } from "react";
import CustomPopupForm from "../../../../component/customPopupModel";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import DiscountCard from "../../components/discountCard";
import { useSelector } from "react-redux";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";


const DIALOG_TYPES = {
  CREATE: "pricing-tier",
  DELETE: "delete",
};

const PricingTiers = () => {
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [pricingTierData, setPricingTierData] = useState([]);

  useEffect(() => {
    fetchPricingTier();
  }, []);

  const fetchPricingTier = () => {
    axiosInstance
      .get(`/customer/store/pricing-tiers/store/${storeId}`)
      .then((res) => {
        const formattedUser = res.data.map((item) => ({
          id: item?.id,
          minQnt:item?.service_type === 'WASH_N_FOLD' ? item?.fromQuantity : parseInt(item?.fromQuantity),
          maxQnt:item?.service_type === 'WASH_N_FOLD' ? item?.toQuantity : parseInt(item?.toQuantity),
          // maxQnt: item?.toQuantity,
          discount: parseInt(item?.discount),
          points: item?.features,
          status: item?.status,
          startDate: item?.startDate,
          endDate: item?.endDate,
          serviceType:item?.service_type || "",
        }));
        setPricingTierData(formattedUser);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setDialogType("");
  };
  const handleAddTricing = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleEdit = (row) => {
    setMode("edit");
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setDialogType(DIALOG_TYPES.DELETE);
    setOpenDialog(true);
  };

  const handleDeleteConfirm = async (id) => {
    try {
      await axiosInstance.delete(`/customer/store/pricing-tiers/delete/${id}`);
      fetchPricingTier();
    } catch (error) {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong! Unable to delete",
          "error"
        );
    } finally {
      handleCloseDialog();
    }
  };

  const handleSubmit = () => {
    fetchPricingTier();
    handleCloseDialog();
  };

  return (
    <div className="px-6">
      <div className="flex justify-between items-center w-full ml-3 pr-3">
        <h2 className="text-2xl font-semibold">Pricing Tiers</h2>
        <CustomButton
          onClick={() => handleAddTricing()}
          customeClass="gradient-button w-[140px] h-[45px] mr-1"
        >
          Create
        </CustomButton>
      </div>
      <div className="overflow-y-auto p-6 ml-2 mt-4 scrollbar-hide h-[calc(100vh-170px)] bg-white shadow-md rounded-xl">
        {pricingTierData.length > 0 ? (
          <div className="flex flex-wrap justify-center gap-6">
            {pricingTierData.map((card, index) => (
              <DiscountCard
                key={index}
                cardDetails={card}
                isSelected={selectedIndex === index}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            ))}
          </div>
        ) : (
          <div className="flex h-full justify-center items-center">
            <div className="bg-gradient-to-br from-[#E0F2FE] to-[#EBF4F9] rounded-2xl px-8 py-10 shadow-md border border-[#C5DCEC] ">
              <h3 className="text-lg font-semibold text-[#084C91]">
                No data available for pricing tier
              </h3>
            </div>
          </div>
        )}
      </div>

      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={selectedRow}
          onSubmit={handleSubmit}
        />
      )}

      {dialogType === DIALOG_TYPES.DELETE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.DELETE}
          onDelete={handleDeleteConfirm}
          dialogDetails={{
            title: "Delete Confirmation",
            content: "Are you sure you want to delete discount card?",
            rowData: selectedRow,
          }}
        />
      )}
    </div>
  );
};

export default PricingTiers;
